<template>
  <span
    class="HorBarItem_textUp"
    :style="{ '--mixtmt_mixvw': cssDynamicObj.mixvw }"
  >
    <span class="HorBarItem_textArea">
      <span class="textArea_name" v-text="data.name"></span>
      <span class="textArea_nth" v-text="data.nth"></span>
    </span>
    <span class="HorBarItem_barBg">
      <span
        class="HorBarItem_BarAbs"
        :style="{ width: `${data.valPer ? data.valPer + '%' : 0}` }"
      ></span>
    </span>
  </span>
</template>

<script>
// 横向 bar条  单个
export default {
  name: 'HorBarItem_textUp',
  props: {
    data: {
      type: Object,
      default: () => ({
        name: '200米',
        nth: '1st',
        valPer: '70',
      }),
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.HorBarItem_textUp {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  .HorBarItem_textArea {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    height: calc(1.388vw * var(--mixtmt_mixvw));
    margin-bottom: calc(0.278vw * var(--mixtmt_mixvw));
    .textArea_nth,
    .textArea_name {
      width: 50%;
      font-size: calc(1.11vw * var(--mixtmt_mixvw));
      font-weight: bold;
    }
    .textArea_name {
      color: var(--mixtmt_greyColor6);
    }
    .textArea_nth {
      text-align: right;
      color: var(--mixtmt_greyColor3);
    }
  }
  .HorBarItem_barBg {
    position: relative;
    display: block;
    width: 100%;
    height: calc(0.555vw * var(--mixtmt_mixvw));
    border-radius: calc(0.278vw * var(--mixtmt_mixvw));
    background-color: var(--mixtmt_greyColor7);
    .HorBarItem_BarAbs {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 60%;
      height: 100%;
      border-radius: calc(0.278vw * var(--mixtmt_mixvw));
      transition: width 0.3s linear;
      background: linear-gradient(
        180deg,
        var(--mixtmt_theme_defaultGradient_1_1) 0%,
        var(--mixtmt_theme_defaultGradient_1_2) 98%
      );
    }
  }
}
</style>
